/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery( function( $ ) {

  // Hide header on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 25;
  var masthead = $('header#masthead')
  var offcanvas = $('.off-canvas')
  var navbarHeight = masthead.outerHeight();
  var $wpAdminBar = $('#wpadminbar');

  $(document).ready(function() {

      // set padding for sticky header
      setContentPadding();
      $(window).resize(function() {
          setContentPadding();
      });

      var menu_items = $('#primary-mobile-nav .menu-item.menu-item-has-children');
      var nav_toggle = '<i class="mobile-submenu-toggle js-mobile-submenu-toggle fas fa-chevron-down"></i>';
      $.each(menu_items, function(i, item) {

          var submenu = $(this).find('.menu').first();

          if(submenu.length && ! submenu.hasClass('level-2')) {
              $(nav_toggle).insertBefore( submenu );
          }

      });

      $('body').on('click', '.js-mobile-submenu-toggle', function(e) {
          var submenu = $(this).closest('.menu-item-has-children').find('.level-1');

          if(submenu.css('display') == 'block') {
              submenu.hide();
          }
          else {
              submenu.show();
          }
      });
  });

  $(window).scroll(function(event){
      var st = $(this).scrollTop();
      didScroll = true;

      var additionalHeight = 0;
      if ($wpAdminBar.length) {
        additionalHeight = $wpAdminBar.height()
      }

      var topOfDiv = $('.off-canvas-content').position().top;
      if ( st >= topOfDiv ) {
        masthead.addClass('nav-top');
        offcanvas.addClass('nav-top');
      } else {
        masthead.removeClass('nav-top');
        offcanvas.removeClass('nav-top');
      }
  });

  $('#main-nav, #secondary-nav').on(
    'show.zf.dropdownmenu', function() {
      var dropdown = $(this).find('.is-dropdown-submenu');
      dropdown.css('display', 'block');
      dropdown.addClass('active-dropdown');
      masthead.addClass('active-submenu')
      $('body').css('overflow-y', 'hidden');
  });
  $('#main-nav, #secondary-nav').on(
    'hide.zf.dropdownmenu', function() {
      var dropdown = $(this).find('.is-dropdown-submenu');
      dropdown.css('display', 'block');
      dropdown.removeClass('active-dropdown');
      masthead.removeClass('active-submenu')
      $('body').css('overflow-y', 'visible');
  });

  $(window).load(function(event){
    var st = $(this).scrollTop();
    var topOfDiv = $('.off-canvas-content').position().top;

    if ( st > topOfDiv ) {
      masthead.removeClass('nav-top').addClass('nav-scrolled');
      offcanvas.removeClass('nav-top').addClass('nav-scrolled');
    }
  });

    $("#primary_nav_mobile").on("on.zf.toggler", function(e) {
        $('.js-mobile-nav-toggle').removeClass('closed');
    })
    $("#primary_nav_mobile").on("off.zf.toggler", function(e) {
        $('.js-mobile-nav-toggle').addClass('closed');
    });

  setInterval(function() {
      if (didScroll) {
          hasScrolled();
          didScroll = false;
      }
  }, 150);

  function hasScrolled() {
      var st = $(this).scrollTop();

      // Make scroll more than delta
      if(Math.abs(lastScrollTop - st) <= delta)
          return;

      // If scrolled down and past the navbar, add class .nav-up.
      if ( st > navbarHeight ) {
        masthead.removeClass('nav-top').addClass('nav-scrolled');
        offcanvas.removeClass('nav-top').addClass('nav-scrolled');
      } else {
        masthead.removeClass('nav-scrolled').addClass('nav-top');
        offcanvas.removeClass('nav-scrolled').addClass('nav-top');
      }

      if (st > lastScrollTop && st > navbarHeight){
          // Scroll Down
          masthead.removeClass('nav-down').addClass('nav-up');
          offcanvas.removeClass('nav-down').addClass('nav-up');
      } else {
          // Scroll Up
          if(st + $(window).height() < $(document).height()) {
              masthead.removeClass('nav-up').addClass('nav-down');
              offcanvas.removeClass('nav-up').addClass('nav-down');

          }
      }

      lastScrollTop = st;
  }

  function setContentPadding() {
      // set content padding for sticky header
      var height = masthead.height();

      // if we're on a smaller screen and the header is too larger
      if(300 < height && $(window).width() < 600) {
          // just make it static
          $('#masthead').css('position', 'static');
          $('body').css('padding-top', 0);
      }
      else {
          // otherwise add padding to the top of the body and make header sticky
          $('body').css('padding-top', height);
          $('#masthead').css('position', 'fixed');
      }

  }

});
